import { render } from "./ManagePayments.vue?vue&type=template&id=54006afe"
import script from "./ManagePayments.vue?vue&type=script&lang=js"
export * from "./ManagePayments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__